import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './ru.json';
import uz from './uz.json';

/**
 * Russian is the default: the office staff who use this dashboard work in
 * Russian, matching the b2b storefront. Uzbek is available for the warehouse.
 */
export const LOCALES = ['ru', 'uz'] as const;
export type Locale = (typeof LOCALES)[number];

const STORAGE_KEY = 'riba-admin-locale';

function initialLocale(): Locale {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === 'uz' ? 'uz' : 'ru';
}

void i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    uz: { translation: uz },
  },
  lng: initialLocale(),
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
});

export function setLocale(locale: Locale): void {
  localStorage.setItem(STORAGE_KEY, locale);
  void i18n.changeLanguage(locale);
}

export default i18n;
